import { createAction } from "@reduxjs/toolkit";
export const toggleTheme = createAction("user/toggleTheme");

export const updateGasPrice = createAction("user/updateGasPrice");
